'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = exports.Grid = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        width: ', '%;\n      '], ['\n        width: ', '%;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 0;\n  > * {\n    font-size: ', 'px;\n    display: inline-block;\n    vertical-align: top;\n    width: 100%;\n  }\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  font-size: 0;\n  > * {\n    font-size: ', 'px;\n    display: inline-block;\n    vertical-align: top;\n    width: 100%;\n  }\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledMediaResponsive = require('styled-media-responsive');

var _styledMediaResponsive2 = _interopRequireDefault(_styledMediaResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultGutter = 20;
var defaultFontSize = 16;

var getGridHorizontalRules = function getGridHorizontalRules(_ref) {
  var center = _ref.center;
  return center && ' text-align: center;';
};

var getGridVerticalRules = function getGridVerticalRules(_ref2) {
  var middle = _ref2.middle,
      bottom = _ref2.bottom;

  if (middle) {
    return '> * { vertical-align: middle; }';
  } else if (bottom) {
    return '> * { vertical-align: bottom; }';
  } else return;
};

var getGridGutterRules = function getGridGutterRules(_ref3) {
  var gutter = _ref3.gutter,
      full = _ref3.full;

  var value = gutter ? gutter : defaultGutter;
  if (full) {
    return '\n    margin-left: 0px;\n    > * {\n      padding-left: 0px;\n    }\n  ';
  } else {
    return '\n    margin-left: ' + value * -1 + 'px;\n    > * {\n      padding-left: ' + value + 'px;\n    }\n  ';
  }
};

var getDirectionRules = function getDirectionRules(_ref4) {
  var rev = _ref4.rev;
  return rev && '\n    direction: rtl;\n    text-align: left;\n    > * {\n      direction: ltr;\n      text-align: left;\n    }\n  ';
};

var getGridItemMediaRules = function getGridItemMediaRules(_ref5) {
  var media = _ref5.media,
      theme = _ref5.theme;

  var rules = [];
  var mq = (0, _styledMediaResponsive2.default)(theme.breakpoints);
  media && Object.keys(media).forEach(function (breakpoint) {
    if (mq[breakpoint]) {
      var columns = media[breakpoint];
      var percent = columns * 100;
      rules.push(mq[breakpoint](_templateObject, percent).join(''));
    } else {
      console.log('breakpoint "' + breakpoint + '" doesn\'t exist or it hasn\'t been defined on your theme');
    }
  });
  return rules.join(' ');
};

var getGridItemWidthRules = function getGridItemWidthRules(_ref6) {
  var col = _ref6.col;

  var percent = col * 100;
  return 'width: ' + percent + '%;';
};

var Grid = exports.Grid = _styledComponents2.default.div(_templateObject2, defaultFontSize, function (props) {
  return getGridGutterRules(props);
}, function (props) {
  return getGridHorizontalRules(props);
}, function (props) {
  return getGridVerticalRules(props);
}, function (props) {
  return getDirectionRules(props);
});

var GridItem = exports.GridItem = _styledComponents2.default.div(_templateObject3, function (props) {
  return getGridItemWidthRules(props);
}, function (props) {
  return getGridItemMediaRules(props);
});